import React from "react";

const SadEmojiIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 57 57"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57 28.5C57 44.2401 44.2401 57 28.5 57C12.7599 57 0 44.2401 0 28.5C0 12.7599 12.7599 0 28.5 0C44.2401 0 57 12.7599 57 28.5ZM28.5 54.15C42.6661 54.15 54.15 42.6661 54.15 28.5C54.15 14.3339 42.6661 2.85 28.5 2.85C14.3339 2.85 2.85 14.3339 2.85 28.5C2.85 42.6661 14.3339 54.15 28.5 54.15Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6213 42.606C17.1365 43.2009 18.0364 43.2655 18.6313 42.7503C19.6319 41.8838 21.071 41.1643 22.804 40.664C24.537 40.1637 26.5029 39.9003 28.504 39.9003C30.5052 39.9003 32.471 40.1637 34.204 40.664C35.9371 41.1643 37.3762 41.8838 38.3767 42.7503C38.9716 43.2655 39.8716 43.2009 40.3868 42.606C40.902 42.0111 40.8374 41.1111 40.2425 40.5959C38.8384 39.3799 36.9882 38.5013 34.9945 37.9258C32.9782 37.3437 30.7437 37.0503 28.504 37.0503C26.2644 37.0503 24.0299 37.3437 22.0136 37.9258C20.0199 38.5013 18.1697 39.3799 16.7656 40.5959C16.1707 41.1111 16.106 42.0111 16.6213 42.606Z"
    />
    <path d="M22.8016 22.7997C22.8016 24.3737 21.5256 25.6497 19.9516 25.6497C18.3776 25.6497 17.1016 24.3737 17.1016 22.7997C17.1016 21.2257 18.3776 19.9497 19.9516 19.9497C21.5256 19.9497 22.8016 21.2257 22.8016 22.7997Z" />
    <path d="M39.8953 22.7997C39.8953 24.3737 38.6193 25.6497 37.0453 25.6497C35.4713 25.6497 34.1953 24.3737 34.1953 22.7997C34.1953 21.2257 35.4713 19.9497 37.0453 19.9497C38.6193 19.9497 39.8953 21.2257 39.8953 22.7997Z" />
  </svg>
);

export default SadEmojiIcon;
